import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { MenuItemType } from '../../types/menu-item/menu-item.type';
import { VisibilityHistoryType } from '../../types/visibility-history/visibility-history.type';
import { rejectWithApiError } from '../../utils/api';
import { RootReducerState } from '../../redux/Reducers';

export const getAccessAndVisibilityData = createAsyncThunk<
  Array<MenuItemType & { value?: boolean; parentValue?: boolean }>,
  { orgId: number },
  { state: RootReducerState }
>('accessAndVisibility/getAccessAndVisibilityData', async ({ orgId }, thunkAPI) => {
  try {
    const response = await axios.get<Array<MenuItemType>>(
      `${process.env.REACT_APP_API_URL}/feature-visibility?org_id=${orgId}`
    );
    return response.data;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error, fallback: 'Error during fetching access and visibility data!' });
  }
});

export const patchOrganizationAccessAndVisibilityDetails = createAsyncThunk<
  { success: boolean },
  { orgId: number; data: any },
  { state: RootReducerState }
>('accessAndVisibility/patchOrganizationAccessAndVisibilityDetails', async ({ data, orgId }, thunkAPI) => {
  try {
    const response = await axios.patch<{ success: boolean }>(
      `${process.env.REACT_APP_API_URL}/feature-visibility?org_id=${orgId}`,
      data
    );
    return response.data;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error, fallback: 'Error during updating access and visibility data!' });
  }
});

export const getVisibilityHistory = createAsyncThunk<
  Array<VisibilityHistoryType>,
  { orgId: number },
  { state: RootReducerState }
>('accessAndVisibility/getVisibilityHistory', async ({ orgId }, thunkAPI) => {
  try {
    const response = await axios.get<Array<VisibilityHistoryType>>(
      `${process.env.REACT_APP_API_URL}/feature-visibility/history?org_id=${orgId}`
    );
    return response.data;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error, fallback: 'Error during fetching visibility history!' });
  }
});
